export default __webpack_public_path__ + "static/media/iconEdit.7f712d43.svg";